import RequestAbstract from "../abstract";

export default class Coins extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/coins";
    }
}
